import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'theme/theme';
import utils from 'helpers/utils';
import translate from 'components/hoc/translate';
import Table from 'components/ui/table/Table';
import TableRow from 'components/ui/table/TableRow';
import HeaderColumn from 'components/ui/table/HeaderColumn';
import TextField from './TextField';
import TableBodyCell from 'components/table/TableBodyCell';

const TextFieldWrapper = styled.div`
    margin: 0 0 20px 0;
`;

const Title = styled.p`
    font-size: 15px;
    font-weight: bold;
    line-height: 1.4;
    color: ${ theme.palette.black }
`;

const MembershipScheduleField = ({ schedule, translate, title }) => {
    if (utils.isEmpty(schedule)) {
        return null;
    }

    return (
        <TextFieldWrapper>
            <Title>{ title || '' }</Title>

            <Table>
                <TableRow>
                    <HeaderColumn>{translate('resources.subscriptionProducts.input.day.1')}</HeaderColumn>
                    <HeaderColumn>{translate('resources.subscriptionProducts.input.day.2')}</HeaderColumn>
                    <HeaderColumn>{translate('resources.subscriptionProducts.input.day.3')}</HeaderColumn>
                    <HeaderColumn>{translate('resources.subscriptionProducts.input.day.4')}</HeaderColumn>
                    <HeaderColumn>{translate('resources.subscriptionProducts.input.day.5')}</HeaderColumn>
                    <HeaderColumn>{translate('resources.subscriptionProducts.input.day.6')}</HeaderColumn>
                    <HeaderColumn>{translate('resources.subscriptionProducts.input.day.7')}</HeaderColumn>
                </TableRow>

                <TableRow>
                    {
                        Array.from({ length: 7 }, (_, day) => {
                            const entryForDay = schedule.entries.find((entry) => {
                                return entry.day === day + 1;
                            });

                            const value = entryForDay ? `${ entryForDay.starts_at } - ${ entryForDay.ends_at }` : '-';

                            return (
                                <TableBodyCell
                                    field={ <TextField value={ value } /> }
                                    key={ day }
                                    record={ {} }
                                />
                            );
                        })
                    }
                </TableRow>
            </Table>
        </TextFieldWrapper>
    );
};

MembershipScheduleField.propTypes = {
    schedule: PropTypes.shape({
        name: PropTypes.string,
        entries: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,
    translate: PropTypes.func.isRequired,
    title: PropTypes.string,
};

export default translate(MembershipScheduleField);



// WEBPACK FOOTER //
// ./src/components/show/MembershipScheduleField.js